import React, { useEffect } from 'react'
import FormSearch from './formSearch'
import { Form } from 'antd'
import useHome from '../../context/useHome';
import redcrossLogo from '../../../../assets/images/home/redcross.png'
import { useNavigate, useParams } from 'react-router-dom';
import { setSearchHistoryStorage, rmSearchHistoryStorage, getSearchHistoryStorage } from '../../../../utils/localStorage'


const BottomBanner = () => {
    const [form] = Form.useForm();
    const { query, setQuery, cards } = useHome()
    const { org } = useParams()
    const history = useNavigate()

    useEffect(() => {
        let buCode = null
        if (org && cards) {
            const _org = cards.find(item => item.orgUnitName === org)
            if (_org && _org.orgUnitCode !== '00') {
                buCode = _org.orgUnitCode
            }
        }

        // กำหนดค่าเริ่มต้นของฟอร์ม
        const defaultFormValues = {
            searchKeyword: null,
            bu: buCode ?? "all",
            orgUnit: ["all"],
            positionGroup: ["all"],
            employmentType: ["all"],
            positionCareer: ["all"],
            province: ["all"],
            isAnnual: true,
            isNotAnnual: true,
            isGeneral: true,
            isNotGeneral: true
        };

        // ดึงข้อมูลการค้นหาที่บันทึกไว้จาก localStorage
        const savedData = getSearchHistoryStorage()

        //ถ้า savedData มีค่า หมายถึงเคยค้นหามาก่อน จะเก็บค่า savedData ถ้า savedData เป็น null เก็บค่าฟอร์มเริ่มต้นคือ defaultFormValues
        const valuesToUse = savedData ? { ...savedData } : defaultFormValues;

        // เรียกเซตฟอร์ม ขึ้นอยู่กับว่า valuesToUse มีค่าอะไร
        form.setFieldsValue(valuesToUse) 
       
        setQuery(_query => ({
            searchKeyword: valuesToUse.searchKeyword,
            buCode: valuesToUse.bu === 'all' ? null : valuesToUse.bu,
            orgUnitName: valuesToUse.orgUnit?.includes('all') ? null : valuesToUse.orgUnit?.join(','),
            positionGroupName: valuesToUse.positionGroup?.includes('all') ? null : valuesToUse.positionGroup?.join(','),
            employmentTypeName: valuesToUse.employmentType?.includes('all') ? null : valuesToUse.employmentType?.join(','),
            positionCareerName: valuesToUse.positionCareer?.includes('all') ? null : valuesToUse.positionCareer?.join(','),
            province: valuesToUse.province?.includes('all') ? null : valuesToUse.province?.join(','),
            // ห้าม default false ให้กับ isAnnual และ isNotAnnual เพราะมีผลกับการค้นหา Mobile view
            isAnnual: valuesToUse.isAnnual,
            isNotAnnual: valuesToUse.isNotAnnual,
            isGeneral: valuesToUse.isGeneral ?? false,
            isNotGeneral: valuesToUse.isNotGeneral ?? false,
            fetchHome: !query.fetchHome
        }));
    }, [org, cards]); // กำหนดให้ useEffect ทำงานเมื่อ org หรือ cards เปลี่ยนแปลง

    const onFinish = async (data) => {
        const _query = {
            searchKeyword: data.searchKeyword,
            buCode: data.bu === 'all' ? null : data.bu,
            orgUnitName: data?.orgUnit ? data?.orgUnit.includes('all') ? null : data.orgUnit.join(',') : null,
            positionGroupName: data?.positionGroup ? data?.positionGroup.includes('all') ? null : data.positionGroup.join(',') : null,
            employmentTypeName: data?.employmentType ? data?.employmentType.includes('all') ? null : data.employmentType.join(',') : null,
            positionCareerName: data?.positionCareer ? data?.positionCareer.includes('all') ? null : data.positionCareer.join(',') : null,
            province: data?.province ? data?.province.includes('all') ? null : data.province.join(',') : null,
            // ห้าม default false ให้กับ isAnnual และ isNotAnnual เพราะมีผลกับการค้นหา Mobile view
            isAnnual: data.isAnnual,
            isNotAnnual: data.isNotAnnual,
            isGeneral: data.isGeneral ?? false,
            isNotGeneral: data.isNotGeneral ?? false,
            fetchHome: !query.fetchHome
        }

        setQuery(_query)

        let _org = null
        if (data.bu && data.bu !== 'all') {
            _org = cards.find(item => item.orgUnitCode === data.bu)
        } else {
            _org = cards.find(item => item.orgUnitCode === '00')
        }
        await setSearchHistoryStorage({...data, orgUnitName:_org?.orgUnitName})
        history(`/${_org?.orgUnitName}`)
    }

    const onFinishFailed = (data) => {
        console.log('onFinishFailed =>', data)
    }

    const onResetForm = () => {
        form.resetFields()
        form.setFieldsValue({ bu: 'all', isAnnual: true, isNotAnnual: true, isGeneral: true, isNotGeneral: true })
    
        rmSearchHistoryStorage();
    };

    return (
        <div className='bottom-home-banner'>
            <div className="image-banner absolute">
                <img alt='redcross' src={redcrossLogo} />
            </div>
            <div className="container div-form-search flex margin-auto items-end px-4">

                <Form
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    form={form}
                    className='w-full form-search'
                    layout={'vertical'}
                >
                    <FormSearch resetForm={onResetForm} form={form} />
                </Form>
            </div>
        </div>
    )
}

export default BottomBanner